
import { Component } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'

@Component({})
export default class extends ListViewVue {
  listType = "router";

  /** /manager/sign/list 只认 page / pageSize，多送字段会被 DTO 打回，所以没有筛选条件 */
  getCondition() {
    return {}
  }

  async getList() {
    return this.$post("/manager/sign/list", { ...this.mesureData });
  }

  /**
   * 用 $post 手动弹错而不是 $postError：已有报名记录时后端会拒绝删除，
   * $postError 是 toast 完再 throw，在 el-popconfirm 的回调里会变成未捕获的 rejection
   */
  async delRow(id) {
    let { error, message } = await this.$post("/manager/sign/delete", { id });
    if (error) return this.$error(message);
    this.$success("删除成功");
    this.refresh();
  }

  /**
   * 按 path 跳而不是 name：name 取的是后端菜单的 aliasName，前端拿不到，
   * 菜单里的路径才是两边之间的约定。
   *
   * 路径是菜单树上各层的 path 拼出来的：应用(application) → 优惠券容器(空) → 报名活动(sign) → operat，
   * 和 /shop/order/warehouse/operat 一个道理。菜单里改了 path，这里要跟着改。
   */
  operat(id?) {
    this.$goto({
      path: "/application/sign/operat",
      query: id ? { id } : undefined,
    });
  }

  record(id) {
    this.$goto({
      path: "/application/sign/record",
      query: { id },
    });
  }
}
